// src/i18n/translationsLoader.js
// Lädt einmalig beim App-Start das DB-Übersetzungs-Bundle und hält es im
// Speicher. fieldMapping.js fragt hier zuerst nach einem Override, bevor es
// auf die statischen de.js/en.js/... Dateien zurückfällt — so bricht nichts,
// solange die Migration läuft oder das Bundle mal nicht erreichbar ist.

import { isPrerender } from "../components/isPrerender";

let overrides = {}; // { lang: { key: value } }
let activeLanguages = null;
let activeLanguageDetails = null; // [{ code, name, flag_data }]
let loaded = false;

const TRANSLATIONS_API_BASE = "https://partners.gotransfer24.de/api";

export async function loadTranslationsBundle() {
  // Im react-snap-Prerender ist die Live-API per CORS nicht erreichbar → statische Dateien nutzen
  if (isPrerender) return;
  try {
    const res = await fetch(`${TRANSLATIONS_API_BASE}/translations/bundle`);
    if (!res.ok) return;
    const data = await res.json();
    overrides = data.bundle || {};
    activeLanguages = data.languages || null;
    activeLanguageDetails = data.languageDetails || null;
    loaded = true;
    window.dispatchEvent(new Event("translations-updated"));
  } catch (err) {
    console.warn("Übersetzungs-Bundle konnte nicht geladen werden, nutze statische Dateien:", err.message);
  }
}

export function getOverride(lang, key) {
  return overrides[lang]?.[key];
}

export function getActiveLanguages() {
  return activeLanguages;
}

// Volle Sprachobjekte (Code, Name, Flagge) für den Sprachumschalter im Header.
export function getActiveLanguageDetails() {
  return activeLanguageDetails;
}

export function isTranslationsLoaded() {
  return loaded;
}